<template>
  <v-dialog
    v-model="routesFilterDialog"
    @submit="applyFilters()"
    @reset="resetFilters()"
    width="30%"
    ><v-card>
      <v-card-title>
        <v-row class="d-flex justify-space-between">
          <v-col cols="6">
            <h3 class="text-body-1 primary--text font-weight-bold">
              Routes Filter
            </h3>
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <v-icon @click="routesFilterDialog = false" color="primary"
              >mdi-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-form ref="routeFilterForm">
          <v-row no-gutters>
            <v-col cols="12" md="6" lg="6" xl="6" class="">
              <BaseSelect
                dense
                hide-details
                outlined
                clearable
                label="Select Project"
                :itemsList="projectList"
                itemText="name"
                itemValue="value"
                :multiple="true"
                v-model="routeFilter.project_id"
                class="pl-1"
                :menu-props="{ offsetY: true }"
                @change="syncRoutesFilter('project_id', $event)"
              ></BaseSelect>
            </v-col>

            <v-col cols="12" md="6" lg="6" xl="6" class="pl-2">
              <BaseSelect
                id="companyFilter"
                dense
                hide-details
                outlined
                clearable
                label="Select Organization"
                :itemsList="companyList"
                itemText="name"
                itemValue="value"
                :multiple="true"
                v-model="routeFilter.company_id"
                :menu-props="{ offsetY: true }"
                @change="syncRoutesFilter('company_id', $event)"
              ></BaseSelect>
            </v-col>

            <v-col cols="12" md="12" lg="12" xl="12" class="pt-2 pl-1">
              <BaseSelect
                v-model="routeFilter.route_type"
                :itemsList="routeTypeOptions"
                itemText="name"
                itemValue="value"
                id="routeTypeFilter"
                name="routeTypeFilter"
                label="Route Type"
                @change="syncRoutesFilter('route_type', $event)"
                :isClearable="false"
                :isSearchRequired="false"
              ></BaseSelect>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end">
        <BaseSecondaryButton
          small
          customClass="rounded-lg"
          id="resetRouteFilter"
          @click="resetFilters()"
          >Reset</BaseSecondaryButton
        >
        <BaseButton
          small
          customClass="rounded-lg"
          id="applyRouteFilter"
          @click="applyFilters()"
          >Apply</BaseButton
        >
      </v-card-actions>
    </v-card></v-dialog
  >
</template>

<script>
import { routeTypeOptions } from "@/utils/optionsMapping.js";
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      routeTypeOptions,
      projectList: [],
      companyList: [],
      routeFilter: {},
    };
  },
  watch: {
    routesFilterDialog(value) {
      if (value) {
        this.getProjectsList();
        this.getCompanyList();
        let filters = localStorage.getItem("routeFilters");
        if (!filters) {
          filters = {};
        }
        if (typeof filters == typeof "string") {
          filters = JSON.parse(filters);
        }
        this.routeFilter = filters;
      }
    },
  },
  computed: {
    routesFilterDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getProjectsList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      this.$api.projects.getProjectList(params).then((res) => {
        this.projectList = res.data.map((obj) => {
          return {
            name: obj.project_name,
            value: obj.project_id,
          };
        });
      });
    },
    getCompanyList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      this.$api.company.getCompanyList(params).then((res) => {
        this.companyList = res.data.map((obj) => {
          return {
            name: obj.name,
            value: obj.company_id,
          };
        });
      });
    },
    syncRoutesFilter(key, value) {
      let filters = localStorage.getItem("routeFilters");
      if (!filters) {
        filters = {};
      }
      if (typeof filters == typeof "string") {
        filters = JSON.parse(filters);
      }
      if (value !== null && value.length > 0) {
        filters[key] = value;
      } else {
        delete filters[key];
      }
      this.routeFilter = filters;
      localStorage.setItem("routeFilters", JSON.stringify(filters));
    },
    applyFilters(reload) {
      this.$emit("routeFiltersChanged");
      this.routesFilterDialog = false;
    },
    resetFilters(reload) {
      this.routeFilter = {};
      localStorage.removeItem("routeFilters");
      this.$emit("routeFiltersChanged");
      if (this.$refs.routeFilterForm) {
        this.$refs.routeFilterForm.reset();
      }
    },
  },
};
</script>

<style>
</style>